import styled from "styled-components";

export const CMHeadingContainer = styled.div((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexGrow: 1,
  height: 410,

  "& h3": {
    margin: 0,
    paddingRight: 25,
    paddingLeft: 18,
    fontFamily: props.theme.fontFamilies.workSans,
    fontWeight: "normal",
    textAlign: "center",
  },

  [`@media${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
  },

  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
  },
}));
export const CMOffer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",

  "& Button": {
    height: 53,
    width: 133,
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 28,
    borderRadius: 30,
  },
  
  [`@media ${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const CMBox = styled.div((props) => ({
  display: "flex",
  flexDirection: "column",
}));
